"use client";
import { useAppDispatch } from "@/data/redux/store";
import { GameSystemService } from "@/services";
import TrackingService from "@/services/framework/TrackingService";
import FtlPersistenceService from "@/services/list-builder/FtlPersistenceService";
import PersistenceService from "@/services/list-builder/PersistenceService";
import StudioApiService from "@/services/StudioApiService";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export default function SharePage({ id, rangerList }) {
  const router = useRouter();
  const dispatch = useAppDispatch();

  useEffect(() => {
    StudioApiService.getSharedList(id, rangerList).then((list) => {
      const ftl = !!list.ships;

      const gs = GameSystemService.parse(list.gameSystem);
      const slug = GameSystemService.findById(gs).slug;

      const callback = () => {
        TrackingService.TrackEvent("load-from-share", "Loaded from share");
        router.push(`/view/${slug}`);
      };

      if (ftl) {
        FtlPersistenceService.loadFromShare(dispatch, list, callback);
      } else {
        PersistenceService.loadFromShare(dispatch, list, callback);
      }
    });
  }, []);

  return <></>;
}
